import React from 'react'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { layerManage } from '@/utils/layer'
import { Row, Expaned, Column } from '@/components/layout/layout'
import SelectGoodsList from './component/select-goods-list'
import SelectGoodsGroup from './component/select-goods-group'
import SelectGoodsTable from './component/select-goods-table'

import './select-goods.scss'
import { getBEMCls } from '@/utils/classname'
import SearchInput from '@/components/search-input/search-input'
import { Goods } from '@/model/types/goods'
import { selectGoodStore } from './model'
import { usePersistFn, useUnmount } from 'ahooks'
import { observer } from 'mobx-react'

export const getSelectGoodsCls = (...arg: string[]) => getBEMCls('select-goods', ...arg)

export const useSelectGoods = () => {
    const reduceGoods = usePersistFn((id: number) => {
        selectGoodStore.setSelectKey(selectGoodStore.selectKey.filter(l => l !== id))
        selectGoodStore.setSelectList(selectGoodStore.selectList.filter(l => l.id !== id))
    })

    const initGoods = usePersistFn((goods: Goods[]) => {
        const selectKey = goods.map(g => g.id)
        selectGoodStore.setSelectKey(selectKey)
        selectGoodStore.setSelectList(goods)
        selectGoodStore.setInitSelectKey(selectKey)
        selectGoodStore.setInitSelectList(goods)
    })

    useUnmount(() => {
        // 组件销毁后进行初始化
        selectGoodStore.reset()
    })

    return {
        reduceGoods,
        initGoods,
    }
}

interface SelectGoodsProps {
    onSubmit: (good: Goods[]) => void
    filterFn?: (good: Goods) => boolean
    confirmOnEnter?: boolean
}

const SelectGoods: React.FC<SelectGoodsProps> = props => {
    return (
        <BaseDialog
            isShow
            title="选择商品"
            onClose={() => {
                layerManage.pop()
                // 关闭弹窗初始化数据
                selectGoodStore.setSelectKey(selectGoodStore.initSelectKey)
                selectGoodStore.setSelectList(selectGoodStore.initSelectList)
                selectGoodStore.setActiveId(void 0)
                selectGoodStore.setSecondId(0)
            }}
            styles={{
                width: '1224px',
            }}
        >
            <Row className={getSelectGoodsCls()}>
                <Expaned>
                    <Column>
                        <div data-margin-right-8 data-expaned>
                            <SearchInput
                                placeholder="输入关键词搜索商品"
                                isExpaned={false}
                                onSearch={value => {
                                    selectGoodStore.setKeyword(value.trim())
                                }}
                            />
                        </div>
                        {selectGoodStore.keyWord && (
                            <Row className={getSelectGoodsCls('searchBox')}>
                                <div>
                                    以下是
                                    <span className="them-color" data-font-weight-600 data-padding-h-8>
                                        {selectGoodStore.keyWord}
                                    </span>
                                    的搜索结果
                                </div>
                                <div
                                    className={getSelectGoodsCls('delete')}
                                    onClick={() => {
                                        selectGoodStore.setKeyword('')
                                    }}
                                >
                                    <i data-cursor-pointer className="iconfont icon6guanbi-20" />
                                </div>
                            </Row>
                        )}
                        <Row data-margin-top-14 className={getSelectGoodsCls('table-container')}>
                            <SelectGoodsGroup />
                            <Expaned>
                                <SelectGoodsTable filterFn={props.filterFn} />
                            </Expaned>
                        </Row>
                    </Column>
                </Expaned>
                <SelectGoodsList onSubmit={props.onSubmit} confirmOnEnter={props.confirmOnEnter} />
            </Row>
        </BaseDialog>
    )
}

export default observer(SelectGoods)
